import React from "react";

// reactstrap components
// import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";

class Download extends React.Component {
  render() {
    return (
      <>
        <section className="">
         
        </section>
      </>
    );
  }
}

export default Download;
